import { render, staticRenderFns } from "./targets.vue?vue&type=template&id=18ff43be&scoped=true&"
import script from "./targets.vue?vue&type=script&lang=js&"
export * from "./targets.vue?vue&type=script&lang=js&"
import style0 from "./targets.vue?vue&type=style&index=0&id=18ff43be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ff43be",
  null
  
)

export default component.exports